import { derivatives } from '#src/lib/share.ts';

export const breakpoints = {
  se: 375,
  mobile: 480,
  tablet: 720,
  laptop: 960,
  desktop: 1200,
  mediumDesktop: 1320,
  mediumLargeDesktop: 1600,
  largeDesktop: 1800,
  post: derivatives.post.width,
  square: derivatives.square.width,
  story: derivatives.story.width,
} as const;

const heightBreakpoints = {
  smallMobile: 670,
  mediumMobile: 725,
} as const;

export type Breakpoint = keyof typeof breakpoints;

export const smallMobileHeightAndAbove =
  `(min-height: ${heightBreakpoints.smallMobile}px)` as const;
export const mediumMobileHeightAndBelow = `(max-height: ${
  heightBreakpoints.mediumMobile - 1
}px)` as const;

export const seAndAbove = `(min-width: ${breakpoints.se}px)` as const;
export const mobileAndAbove = `(min-width: ${breakpoints.mobile}px)` as const;
export const tabletAndAbove = `(min-width: ${breakpoints.tablet}px)` as const;
export const tabletAndBelow = `(max-width: ${
  breakpoints.tablet - 1
}px)` as const;
export const laptopAndAbove = `(min-width: ${breakpoints.laptop}px)` as const;
export const laptopAndBelow = `(max-width: ${
  breakpoints.laptop - 1
}px)` as const;
export const desktopAndAbove = `(min-width: ${breakpoints.desktop}px)` as const;
export const mediumDesktopAndAbove =
  `(min-width: ${breakpoints.mediumDesktop}px)` as const;
export const largeDesktopAndAbove =
  `(min-width: ${breakpoints.largeDesktop}px)` as const;
export const mediumLargeDesktopAndAbove =
  `(min-width: ${breakpoints.mediumLargeDesktop}px)` as const;

export const socialPost =
  `(width: ${derivatives.post.width}px) and (height: ${derivatives.post.height}px)` as const;
export const socialSquare =
  `(width: ${derivatives.square.width}px) and (height: ${derivatives.square.height}px)` as const;
export const socialStory =
  `(width: ${derivatives.story.width}px) and (height: ${derivatives.story.height}px)` as const;

export const composeTeamDesktop =
  `(min-width: ${breakpoints.laptop}px)` as const;
